/* eslint-disable */
export default {
    questionnaires_title_influencing_styles: "Beïnvloedingsstijlen",
    questionnaires_title_working_styles: "Werkstijlen",
    questionnaires_title_personality: "Persoonlijkheid",
    questionnaires_title_motives: "Drijfveren",
    questionnaires_title_intellectual_capabilities: "Intellectueel vermogen",
    questionnaires_title_home: "Thuis",
    questionnaires_title_location: "Op locatie",
    questionnaires_title_willen: "Willen",
    questionnaires_title_waarden: "Waarden",
    questionnaires_title_beinvloeding: "Beïnvloedingsstijlen",
    questionnaires_title_drijfveren: "Drijfveren",
    questionnaires_title_big5: "Big 5",
    questionnaires_title_werkstijlen: "Werkstijlen",
    questionnaires_title_verbalAnalogies: "Verbale analogieën",
    questionnaires_title_abstractMatrix: "Abstracte Matrixtest",
    questionnaires_title_numericalAbility: "Numerieke",
    questionnaires_title_wpq: "WPQ",
    questionnaires_hour_label: "Uur",
    questionnaires_minutes_label: "Minuten",
    questionnaires_minute_label: "Minuut",
    questionnaires_seconds_label: "Seconden",
    questionnaires_second_label: "Seconde",
    questionnaires_title_verbalAbility: "Verbale",
    questionnaires_title_abstractAbility: "Abstract",
    questionnaires_title_verbalAbilityRetest: "Verbale (hertest)",
    questionnaires_title_numericalAbilityRetest: "Numerieke (hertest)",
    questionnaires_title_abstractAbilityRetest: "Abstracte (hertest)",
    questionnaires_title_buildingDocks: "Building Docks",
    questionnaires_title_beinvloedingShort: "Beïnvloedingsstijlen",
    questionnaires_title_drijfverenShort: "Drijfveren",
    questionnaires_title_big5Short: "Big 5",
    questionnaires_title_werkstijlenShort: "Werkstijlen",
    questionnaires_title_waardenShort: "Waarden",
    questionnaires_title_gMAT1: "GMAT",
    questionnaires_title_gMAT: "G-test",
    questionnaires_title_dilemmaTest: "Dilemmatest",
    questionnaires_title_wpqShort: "WPQ",
    questionnaires_title_vPI: "Persoonlijkheid (VPI)",
    questionnaires_title_gMatMbo: "G-test (mbo)",
    questionnaires_title_criticalThinking: "Kritisch redeneren",
    questionnaires_title_logicalReasoningGame: "Logisch redeneren game",
    questionnaires_title_concentrationGame: "Concentratie game",
    questionnaires_title_numericalInsightGame: "Numerieke inzichten game",
    questionnaires_title_simulationGame: "FrenzyFest",
    questionnaires_title_moodGame: "In Good Mood"
};
